// Приглашение друга (§2.18 «Друзья»; бэкенд e466bfd7): ссылка t.me/<бот>?startapp=ref_<код>. Код уходит ТОЛЬКО
// отдельным POST world/friends/referral/ {code} после любого входа (гость тоже аккаунт), один раз. Храним код до
// ответа: 200 attached или любой 409 (already / self / too_late / code_invalid) — готово, больше не слать;
// сеть или 5xx — пробуем при следующем открытии.
import { splitStartParam } from '../deeplink';
import { apiRequest, ApiError } from '../api/client';

const KEY = 'referral:pending';
const REF = /^ref_([A-Za-z0-9]{4,32})$/;

/** Код из start_param (ref_<код>) или null. */
export function referralCode(param: string | undefined): string | null {
  // рекламная метка после «__» — не часть кода
  const m = REF.exec(splitStartParam(param).dest ?? '');
  return m && /[A-Za-z]/.test(m[1]!) ? m[1]! : null;
}

/** Запомнить код из ссылки запуска (до ответа сервера). */
export function rememberReferral(param: string | undefined): void {
  const code = referralCode(param);
  if (!code) return;
  try { localStorage.setItem(KEY, code); } catch { /* приватный режим — пошлём в этом запуске */ }
  pendingInMemory = code;
}

let pendingInMemory: string | null = null;
let inFlight = false;

function pending(): string | null {
  try { return localStorage.getItem(KEY) ?? pendingInMemory; } catch { return pendingInMemory; }
}

function done(): void {
  pendingInMemory = null;
  try { localStorage.removeItem(KEY); } catch { /* нечего чистить */ }
}

/** Адрес привязки — от адреса мира (без его query). */
export function referralPath(worldPath: string): string {
  const [base = ''] = worldPath.split('?');
  return `${base.endsWith('/') ? base : `${base}/`}friends/referral/`;
}

/** Отправить отложенный код, если он есть. Ответ «привязан» — true (клиент может сказать человеку). */
export async function sendReferral(worldPath: string): Promise<boolean> {
  const code = pending();
  if (!code || inFlight) return false;
  inFlight = true;
  try {
    await apiRequest('POST', referralPath(worldPath), { auth: true, body: { code } });
    done();
    return true;
  } catch (e) {
    // 409 — ответ по существу (уже привязан, свой, поздно, нет такого кода), 400 — битый код: повтор не поможет
    if (e instanceof ApiError && (e.status === 409 || e.status === 400)) done();
    return false;
  } finally {
    inFlight = false;
  }
}
